import { GET_SEARCH_SETTINGS } from '../../constants/ActionTypes';

/**
 * Get search settings.
 * @function getSearchSettings
 * @returns {Object} Get the search settings
 */
export function getSearchSettings() {
  return {
    type: GET_SEARCH_SETTINGS,
    request: {
      op: 'get',
      path: '/@govbrbusca',
    },
  };
}
